import styled, {css} from 'styled-components';

const StyledMarkdown = styled.div`
  ${({theme: {palette, typography}}) => css`
    a {
      text-decoration: none;
      color: ${palette.primary.main};
    }

    h1 {
      ${typography.h1}
    }

    h2 {
      ${typography.h2}
    }

    h3 {
      ${typography.h3}
    }

    h4 {
      ${typography.h4}
    }

    h5 {
      ${typography.h5}
    }

    h6 {
      ${typography.h6}
    }
  `}
`;

export default StyledMarkdown;
